import React from 'react';
import { HelpCircle } from 'lucide-react';

// index.tsx'ten ayrıştırıldı — landing "Faq" bölümü
export default function Faq({ L }: any) {
  return (
    <>
        <section id="faq" className="py-16 md:py-24 relative">
          <div className="divider-glow mb-16 mx-12" />
          <div className="max-w-3xl mx-auto px-6">
            <div className="text-center mb-14">
              <div className="reveal inline-flex items-center gap-2 glass-panel px-4 py-2 rounded-full text-xs text-[#FFB020] uppercase tracking-widest font-semibold mb-6">
                <HelpCircle size={14} /> {L.faq.badge}
              </div>
              <h2
                className="reveal reveal-delay-1 text-4xl md:text-5xl font-black text-white mb-4"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {L.faq.title}
              </h2>
              <p className="reveal reveal-delay-2 text-gray-400 text-lg">
                {L.faq.subtitle}
              </p>
            </div>

            <div className="space-y-4">
              {L.faq.items.map((item, i) => (
                <details
                  key={i}
                  className="reveal glass-panel rounded-2xl border border-white/5 group open:border-[#FFB020]/20 transition-colors"
                >
                  <summary className="cursor-pointer list-none px-6 py-5 flex items-center justify-between gap-4 font-semibold text-white text-sm md:text-base select-none">
                    <span>{item.q}</span>
                    <span className="text-[#FFB020] shrink-0 transition-transform group-open:rotate-180">▾</span>
                  </summary>
                  <div className="px-6 pb-5 text-gray-400 text-sm leading-relaxed border-t border-white/5 pt-4">
                    {item.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

    </>
  );
}
